import { create } from 'zustand';

// Non-persistent auth state. The Cognito session (Amplify localStorage) is the source of
// truth — this store only mirrors the resolved user object so React components can
// re-render off auth state without each one calling `getCurrentUser()`.
const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  isConfigured: false,
  loading: true,

  setUser: (user) => set({ user, isAuthenticated: !!user, loading: false }),
  clearUser: () => set({ user: null, isAuthenticated: false, loading: false }),
  setConfigured: (isConfigured) => set({ isConfigured }),
  setLoading: (loading) => set({ loading }),
}));

export default useAuthStore;
